<script>
import Layout from "../../layouts/main";
import Banner from "@/components/banner.vue"
import FaqS from "@/components/faqComponent.vue"


export default ({
  name: "Faq",

  components: {
    Layout, Banner ,FaqS
  },

  props: {
   
    },

    data() {
        return{
            isCollapsed: []  ,

            open: false
        }
    },
   

  mounted() {
   
  },

  
  methods: {

    toggleCollapse(index) {

      this.$set(this.isCollapsed, index, !this.isCollapsed[index]);

    } ,


  },
      
});


</script>

<template>
  <Layout>
    <Banner pageTitle='MENTIONS LÉGALES' subtitle1="Conditions générales de ventes" subtitle2=" " :small="true" ></Banner>

    <div class="row m-4 p-4">
      <div class="col-12 text-dark font-size-16">

        <p class="text-justify" style="line-height: 30px;
    letter-spacing: 1px;" ><strong>Propriétaire du site «&nbsp;</strong>www.ha.com.tn<strong>» et vendeur des produits&nbsp;:</strong>&nbsp;TRADICO-TUNISIA, Société SARL Anonyme au capital social de 5 000,000 DT, inscrite au registre de commerce de tunis sous le numéro B08228282014, n° de TVA intra-communautaire 1375982 LBM 000(«TRADICO-TUNISIA»).</p>

      <ul class="text-justify" style="line-height: 30px;
    letter-spacing: 1px;">
      <li><strong>Siège social:</strong>&nbsp;TRADICO-TUNISIA, Route Taniour km9 C.P 3041 Chihia - Sfax - Tunisie</li>
      <li><strong>Téléphone:</strong>&nbsp;74 848 220 / Tél&nbsp;: 71 182 702</li>
      <li><strong>E-mail:</strong>&nbsp;<a href="mailto:webmaster@ha.com.tn">webmaster@ha.com.tn</a></li>
      <li><strong>Hébergement:</strong>&nbsp;Le site est hébergé par OVH.</li>
      </ul>

<p class="text-justify" style="line-height: 30px;
    letter-spacing: 1px;"><strong>SECURITE:</strong>&nbsp;Le site marchand www.ha.com.tn est publié sous un protocole sécurisé par Certificat&nbsp; Electronique conformément aux dispositions de la loi n° 200-83 du 9 Août 2000 relative aux échanges, au commerce électronique et à la protection des données personnelles.</p>

      </div>
    </div>

    <FaqS title="Conditions générales de ventes" :faqType="0" > </FaqS>

    

  </Layout>
</template>
<style scoped>


</style>
